'use strict';

angular.module('licensure.services')
    .factory('IPInspections', ['$http', '$q', 'IPChecklists', 'FBResponses', 'TGTriggers', 'Logger', function ($http, $q, IPChecklists, FBResponses, TGTriggers, Logger) {
        var getByID = function (id, getLess) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/IPInspections/' + id, {
                    params: {
                        getLess: getLess
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var save = function (inspection, isSubmit, handleChecklist) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/IPInspections/';
            if (!isUndefined(inspection.id)) {
                method = 'PUT'
                url += inspection.id
            }

            // don't pass in huge response
            var inspectionWithoutChecklist = angular.copy(inspection);
            if (inspectionWithoutChecklist != null) {
                inspectionWithoutChecklist.checklist = null;
            }

            $http({
                method: method,
                url: url,
                data: {
                    inspection: inspectionWithoutChecklist,
                    isSubmit: isSubmit,
                    handleChecklist: handleChecklist
                }
            }).then(function (response) {
                d.resolve(response.data);
            }).catch(function (response) {
                Logger.logAngularApiErrors(response.data, response.status, response.config);
                d.resolve(null);
            });

            return d.promise;
        }

        var saveBatch = function (inspections, isSubmit, handleChecklist) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/IPInspections/saveBatch';

            // shouldn't do it this way
            var isUpdate = inspections.every(function (inspection) {
                return !isUndefined(inspection.id);
            });

            if (isUpdate) {
                method = 'PUT';
                url = apiLocation + '/api/IPInspections/updateBatch';
            }

            inspections = inspections.map(function (inspection) {
                if (inspection != null) {
                    inspection.checklist = null;
                }

                return inspection;
            });

            $http({
                method: method,
                url: url,
                data: {
                    inspections: inspections,
                    isSubmit: isSubmit,
                    handleChecklist: handleChecklist
                }
            })
                .then(function (response) {
                    inspections = [];
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    inspections = [];
                    Logger.logAngularApiErrors(response.data, response.status, response.config);
                });

            return d.promise;
        }

        var saveIPChecklist = function (checklist, inspectionId) {
            return IPChecklists.save(angular.copy(checklist), inspectionId);
        }

        var submit = function (inspection, isSubmit) {
            var d = $q.defer();

            var promises = [];

            promises.push(saveIPChecklist(inspection.checklist, inspection.id));

            $q.all(promises).then(function (arr) {
                var savedChecklist = arr[0];
                if (isSubmit) {
                    // could we move pdf generation into the batch call to inspections, kick off an async pdf generation, and return the document data when inspections return?
                    IPChecklists.generatePDF(inspection).then(function () {
                        if (savedChecklist != null) {
                            save(inspection, isSubmit, false).then(function (savedInspection) {
                                if (savedInspection != null) {
                                    savedChecklist = null;
                                    savedInspection = null;
                                    arr = [];
                                    promises = [];
                                    d.resolve(true);
                                }
                                else {
                                    savedChecklist = null;
                                    savedInspection = null;
                                    arr = [];
                                    promises = [];
                                    d.resolve(false);
                                }
                            });
                        }
                        else {
                            arr = [];
                            d.resolve(false);
                        }
                    });
                }
                else {
                    if (savedChecklist != null) {
                        save(inspection, isSubmit, false).then(function (savedInspection) {
                            if (savedInspection != null) {
                                savedChecklist = null;
                                savedInspection = null;
                                arr = [];
                                promises = [];
                                d.resolve(true);
                            }
                            else {
                                savedChecklist = null;
                                savedInspection = null;
                                arr = [];
                                promises = [];
                                d.resolve(false);
                            }
                        });
                    }
                    else {
                        arr = [];
                        d.resolve(false);
                    }
                }
            }).catch(function (response) {
                // handle error
            });

            return d.promise;
        }

        var submitBatch = function (inspections, isSubmit) {
            var d = $q.defer();

            var promises = [];
            var pdfPromises = [];
            var saveByFormPromises = [];

            var checklists = inspections.map(function (inspection) {
                inspection.checklist.inspection_id = angular.copy(inspection.id); // need to do this because going from single to batch requests
                return inspection.checklist;
            });

            var copyInspections = angular.copy(inspections);

            checklists.forEach(function (checklist) {
                saveByFormPromises.push(FBResponses.saveByForm(checklist.response, checklist.inspection_id, null, null, true, true));
            });

            $q.all(saveByFormPromises).then(function (savedResponses) {
                if (savedResponses != null) {
                    checklists.forEach(function (checklist, idx) {
                        checklist.response = angular.copy(savedResponses[idx]);
                        inspections[idx].checklist = angular.copy(checklist);
                    });

                    IPChecklists.updateBatch(angular.copy(checklists)).then(function (savedChecklists) {
                        if (savedChecklists != null) {
                            saveBatch(angular.copy(inspections), isSubmit, false).then(function (savedInspections) {
                                copyInspections.forEach(function (inspection) {
                                    if (isSubmit) {
                                        pdfPromises.push(IPChecklists.generatePDF(inspection));
                                    }
                                });
                                copyInspections = [];

                                $q.all(pdfPromises).then(function (arr) {
                                    if (savedChecklists != null && savedInspections != null) {
                                        promises = [];
                                        pdfPromises = [];
                                        saveByFormPromises = [];
                                        arr = [];
                                        checklists = [];
                                        inspections = [];
                                        copyInspections = []
                                        savedChecklists = [];
                                        savedInspections = [];
                                        d.resolve(true);
                                    }
                                    else {
                                        promises = [];
                                        pdfPromises = [];
                                        saveByFormPromises = [];
                                        arr = [];
                                        checklists = [];
                                        copyInspections = []
                                        inspections = [];
                                        savedChecklists = [];
                                        savedInspections = [];
                                        d.resolve(false);
                                    }
                                }).catch(function (response) {
                                    // handle error
                                });
                            });
                        }
                        else {
                            promises = [];
                            pdfPromises = [];
                            saveByFormPromises = [];
                            checklists = [];
                            inspections = [];
                            savedChecklists = [];
                            d.resolve(false);
                        }
                    });
                }
            }).catch(function (response) {
                // handle error
            });

            return d.promise;
        }

        var getIDByVisitID = function (visit_id) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/IPInspectionsVisitID/', {
                params: {
                    visit_id: visit_id
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            getByID: getByID,

            submit: submit,

            submitBatch: submitBatch,

            save: save,

            saveBatch: saveBatch,

            getIDByVisitID: getIDByVisitID,

            saveIPChecklist: saveIPChecklist,

            bulkAction: function (inspectionIDs, value, code) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/IPInspections/bulkAction', {
                    inspectionIDs: inspectionIDs,
                    value: value,
                    code: code
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;